import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const FARM_QUERY = gql(`
  query Farm($id: ID!) {
    farm(id: $id) {
      id
      name
      fields {
        id
        name
        area
        length
        currentCrop
      }
    }
  }
`);

interface Result {
  loading: boolean;
  farm: Farm | null;
  fields: Field[];
}

interface Props {
  farmId?: string;
  children: (resut: Result) => React.ReactNode;
}

const FarmFieldsProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery query={FARM_QUERY} variables={{id: props.farmId}}>
    {result => props.children({
      loading: result.loading,
      farm: result.data && result.data.farm,
      fields: result.data && result.data.farm && result.data.farm.fields || [],
    })}
  </AuthorizedQuery>
);

export default FarmFieldsProvider;


// WEBPACK FOOTER //
// ./src/providers/FarmFieldsProvider.tsx